import { supabase } from "@/integrations/supabase/client";

/**
 * Send a server-side event to TikTok Events API via edge function.
 * Fire-and-forget: errors are logged but never block the UI.
 */
export async function sendTiktokServerEvent(params: {
  event: string;
  event_id?: string;
  properties?: Record<string, unknown>;
  email?: string;
  phone_number?: string;
}) {
  try {
    const { event, event_id, properties, email, phone_number } = params;

    await supabase.functions.invoke("tiktok-events", {
      body: {
        event,
        event_id,
        properties,
        email,
        phone_number,
        user_agent: navigator.userAgent,
        page_url: window.location.href,
        page_referrer: document.referrer,
      },
    });
  } catch (err) {
    console.warn("TikTok server event failed (non-blocking):", err);
  }
}
